// import { en } from "../lang/en";
// import { de } from "../lang/de";
// import { useAuth } from "@/auth";




// export function translate(key: string) : string {
//   const { language } = useAuth();
//   const cat = language=="de"?de:en;

  
//     let raw = getByPath(cat, key.replaceAll(" ","")) as string | undefined;
   
//     if (typeof raw !== "string") {
//       // fallback to key for visibility; adjust as you like
//       return key;
//     }
//     return raw;
//   }

// function getByPath(obj: any, path: string): unknown {
//   return path.split(".").reduce((a, p) => (a ? a[p] : undefined), obj);
// }

// export function getDisplayedDate (date:Date) {
//     const { language } = useAuth();
//     return language=="de" ? date.toLocaleDateString("de", { month: "long", year: "numeric" }): date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
//   };


import { en } from "../lang/en";
import { de } from "../lang/de";
import { useAuth } from "@/auth";

function getByPath(obj: any, path: string): unknown {
  return path.split(".").reduce((a, p) => (a ? a[p] : undefined), obj);
}

export function useTranslate() {
  const { language } = useAuth();        // <-- call hook once, here
  const catalog = language === "de" ? de : en;

  const translate = (key: string): string => {
    const raw = getByPath(catalog, key.replaceAll(" ", "")) as string | undefined;
    return typeof raw === "string" ? raw : key;
  };

  const formatMonthYear = (date: Date) =>
    language === "de"
      ? date.toLocaleDateString("de", { month: "long", year: "numeric" })
      : date.toLocaleDateString("en-US", { month: "long", year: "numeric" });

  return { translate, formatMonthYear, language };
}
